import styled from "styled-components";
import logoImg from '../../img/logo-bg_white.png';
function Footer() {
    return(
        <Background>
            <Block className="layout">
                <Flex >
                    {/* Logo  */}
                    <a href="/">
                        <Logo
                            src={logoImg}
                        >
                        </Logo>
                    </a>
                </Flex>
                <Flex flex="3">
                    <Address address="Agionet s.r.o. "
 Částkova 73, 326 00 Plzeň "
                             hrefAddress="https://www.google.com/maps/place/Agionet+s.r.o.+-+design+a+programov%C3%A1n%C3%AD/@49.742077,13.3794653,17z/data=!3m1!4b1!4m6!3m5!1s0x470af1e3947e2fbd:0x86b627aaa52c77ad!8m2!3d49.742077!4d13.3794653!16s%2Fg%2F1pxwsw542"
                             mobile="+420 111 222 333"
                             email="design-exclusive@agionet.cz"
                    />
                </Flex>
                <Flex flex="3">
                    <Pages/>
                </Flex>
                <Flex>
                    <Button>
                        <Icon>

                        </Icon>
                    </Button>
                </Flex>
            </Block>
            <Copyright>
                © 2023 Design | exclusive. All rights reserved.
            </Copyright>
        </Background>
        );
}
const Background = styled.div`
  background-color:white;
  padding: 100px 0 50px 0;
`;
const Block = styled.div`
  display: flex;
  font-family: 'Jost', sans-serif;
  height: 250px;
  font-size:18px;
  @media only screen and (max-width: 750px) {
    display:block;
    height: auto;
  }
`;
const Logo = styled.img`
    width:140px;
`;
const Flex = styled.div`
  flex: ${props => props.flex || '1'};
  padding:0 20px 0 20px;
  @media only screen and (max-width: 750px) {
    padding:0 0 30px 0;
    
  }
`;
const Button = styled.div`
  
`;
const Icon = styled.div`
    
`;
const Copyright = styled.div`
  font-family: 'Jost', sans-serif;
  text-align: center;
`;

function Address(props){
    return(
        <AddressBlock>
            <AdressC>
                <a href={props.hrefAddress}
                   target="_blank"
                   rel="noreferrer"
                >
                    {props.address}
                </a>
            </AdressC>
            <Mobile>
                <a href={`tel:${props.mobile}`}>
                    {props.mobile}
                </a>
            </Mobile>
            <Email>
                <a href={`mailto:${props.email}`}>
                    {props.email}
                </a>
            </Email>
        </AddressBlock>
    );
}
const AddressBlock = styled.div`
  a {
    text-decoration: none;
    color:black;
    transition:0.3s;
  }
`;
const AdressC = styled.div`
  a:hover{
    color: #C92F34;
    text-decoration: underline black;
  }
  a {
    text-decoration: none;
    color:black;
    transition:0.3s;
  }
`;

const Mobile = styled.div`
  padding-top:20px;
  @media only screen and (max-width: 750px) {
    padding-top:0;
    display:block;
    height: auto;
  }
  
`;
const Email = styled.div`
`;
function smoothScroll(id) {
    const element = document.getElementById(id);
    element.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
    });
}
function Pages(props){
    return(
        <div>
            <BlockPages>
                <Flex>
                    <Page page="O nás" id="aboutUs"/>
                    <Page page="Reference" id="References"/>
                    <Page page="Klienti" id="Recommends"/>
                    <Page page="Projekt s námi" id="ProjectUs"/>
                    <Page page="Služby" id="Services"/>
                </Flex>
                <Flex>
                    <PageHref page="Facebook" href="https://www.facebook.com/Agionet.sro"/>
                    <PageHref page="Linkedin" href="https://www.linkedin.com/company/agionet-s-r-o-/mycompany/"/>
                    <PageHref page="Instagram" href="https://www.instagram.com/agionet_sro/"/>
                </Flex>
            </BlockPages>
        </div>
    );
}
const BlockPages = styled.div`
  display: flex;
  margin-bottom:30px;
`;
function Page(props){
    return(
        <PageLink >
            <div
                onClick={(e) => {
                    e.preventDefault();
                    smoothScroll(props.id)
                }} href={`${props.page}`}
            >
                {props.page}
            </div>
        </PageLink>
    );
}
function PageHref(props){
    return(
        <PageLink >
            <a
                href={props.href}
                target="_blank"
                rel="noreferrer"

            >
                {props.page}
            </a>
        </PageLink>
    );
}
const PageLink = styled.div`
  div, a {
    text-decoration: none;
    color: black;
    transition: 0.3s;
    cursor:pointer;
  }

  div:hover, a:hover {
    color: #C92F34;
  }
`;

export default Footer;